<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-select`]" width="1em" height="1em" v-bind="$attrs"><rect x="3" y="3" width="18" height="18" rx="4" stroke="#165DFF" stroke-width="1.66" stroke-linejoin="round"/><path d="M7.68359 10.3261L10.8687 13.5112C11.2647 13.9072 11.4627 14.1052 11.691 14.1794C11.8919 14.2446 12.1082 14.2446 12.309 14.1794C12.5374 14.1052 12.7354 13.9072 13.1314 13.5112L16.3165 10.3261" stroke="#00BBD8" stroke-width="1.66" stroke-linecap="round" stroke-linejoin="round"/></svg>
</template>
<script>

export default {
  name: 'IconColorSelect',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
